import useSWR from 'swr';
import type { PropertyRoomOption } from '~/models/PropertyRoomOption';
import type { SwrReturnType } from '~/models/Api';

const paths = {
  index: '/property_room_options'
} as const;

type TIndex = (
  name: string | null,
  address: string | null,
  buildingPropertyId: number | null
) => SwrReturnType<PropertyRoomOption[]>;

type ReturnType = {
  index: TIndex;
};

export const usePropertyRoomOptions = (): ReturnType => {
  const index: TIndex = (
    name: string | null,
    address: string | null,
    amaterasBuildingPropertyId: number | null
  ) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error, isValidating } = useSWR(
      name && address
        ? {
            url: paths.index,
            params: { name, address, amaterasBuildingPropertyId }
          }
        : null
    );
    return {
      data: data ?? null,
      mutate: mutate ?? null,
      isLoading: !data && !error,
      isValidating,
      error
    };
  };
  return { index };
};
